module.exports = __webpack_public_path__ + "static/media/Info.eb46d635.svg";